<template>
<div class="chapter">
<div class="inner_page">
<div id="toc">
<h1 id="toc-title">Beneath the Shelter of an Ancient Tree</h1>
<ol class="toc">
<li id="toc-li-1">
<a href="#/text/ch001#about-the-author">About the Author</a>
</li>
<li id="toc-li-2">
<a href="#/text/ch002#dedication">Dedication</a>
</li>
<li id="toc-li-3">
<a href="#/text/ch003#copyright-information">Copyright Information ©</a>
</li>
<li id="toc-li-4">
<a href="#/text/ch004#acknowledgement">Acknowledgement</a>
</li>
<li id="toc-li-5">
<a href="#/text/ch005#a-family-reveals-its-secrets">1. A Family Reveals Its Secrets</a>
</li>
<li id="toc-li-6">
<a href="#/text/ch006#the-platts-of-saddleworth">2. The Platts of Saddleworth</a>
</li>
<li id="toc-li-9">
<span href="#/text/ch007#sophias-story-the-warp-and-weft-of-family-life" title="Link target outside of Sample">3. Sophia’s Story: The Warp and Weft of Family Life</span>
</li>
<li id="toc-li-15">
<span href="#/text/ch008#a-west-country-odyssey" title="Link target outside of Sample">4. A West Country Odyssey</span>
</li>
<li id="toc-li-27">
<span href="#/text/ch009#the-cheshires-getting-to-know-you" title="Link target outside of Sample">5. The Cheshires – Getting to Know You</span>
</li>
<li id="toc-li-31">
<span href="#/text/ch010#workshop-of-the-world" title="Link target outside of Sample">6. Workshop of the World</span>
</li>
<li id="toc-li-39">
<span href="#/text/ch011#the-last-piece-in-the-jigsaw" title="Link target outside of Sample">7. The Last Piece in the Jigsaw</span>
</li>
<li id="toc-li-49">
<span href="#/text/ch012#the-second-phillips-diaspora" title="Link target outside of Sample">8. The Second Phillips’ Diaspora</span>
</li>
<li id="toc-li-57">
<span href="#/text/ch013#looking-back" title="Link target outside of Sample">9. Looking Back</span>
</li>
<li id="toc-li-61">
<span href="#/text/ch014#appendix-herbert-phillips-settles-in-the-united-states" title="Link target outside of Sample">10. Appendix – Herbert Phillips Settles in the United States</span>
</li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?72f70739